import {Box, Text} from '@logistics-frontend/blocks'
import {type CSSProperties, memo} from 'react'

import {renderWidget} from '../index'
import type {SlotWidgetBody} from '../types'
import * as styles from './SlotBody.classes'

/** Пропсы компонента SlotBody */
type SlotBodyProps = {
  /** Содержимое блока */
  body: SlotWidgetBody
}

/** Мапа из align конфига в justify-content из CSS */
const ALIGN_TO_JUSTIFY_CONTENT_MAP: Record<SlotWidgetBody['align'], CSSProperties['justifyContent']> = {
  leading: 'left',
  center: 'center',
  trailing: 'right',
}

/**
 * Текстовый блок в слоте
 */
export const SlotBody = memo<SlotBodyProps>(function SlotBody({body}) {
  return (
    <Box className={styles.box} flexDirection="column" justifyContent={ALIGN_TO_JUSTIFY_CONTENT_MAP[body.align]}>
      {body.title && <Text className={styles.text}>{body.title.items.map(renderWidget)}</Text>}
      {body.subtitle && <Text className={styles.text}>{body.subtitle.items.map(renderWidget)}</Text>}
    </Box>
  )
})
